import { featureFlagClient } from '@trello/feature-flag-client';

import { ExperimentVariations } from './types';

export const experimentVariation: (
  featureFlag: string,
) => ExperimentVariations = (featureFlag) =>
  featureFlagClient.getTrackedVariation(
    featureFlag,
    ExperimentVariations.NOT_ENROLLED,
  ) as ExperimentVariations;

export const isCompletelyFreeTrial = () =>
  experimentVariation('tofu.no-cc-free-trial') ===
  ExperimentVariations.EXPERIMENT;
